export default __webpack_public_path__ + "static/media/Dither Background.415c5bbd.mp4";